(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verifier"] && !Shopify.designMode) return;
  try {
    
  class AgeVerifier extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey;
      this.days = parseInt(this.dataset.rememberDays, 10) || 30;

      // Never gate the theme editor — the merchant needs to see their content.
      if (window.Shopify && window.Shopify.designMode) return;

      if (this.isVerified()) return;

      this.hidden = false;
      document.body.classList.add('scroll-locked');

      this.querySelector('[data-age-accept]').addEventListener('click', () => this.accept());
      this.querySelector('[data-age-decline]').addEventListener('click', () => this.decline());
    }

    isVerified() {
      try {
        const raw = window.localStorage.getItem(this.key);
        if (!raw) return false;
        return Number(raw) > Date.now();
      } catch (error) {
        // Private browsing can throw on localStorage; fail open.
        return true;
      }
    }

    accept() {
      try {
        const expires = Date.now() + this.days * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(this.key, String(expires));
      } catch (error) {
        /* Nothing to persist to — the gate simply reappears next visit. */
      }
      this.hidden = true;
      document.body.classList.remove('scroll-locked');
    }

    decline() {
      const denied = this.querySelector('[data-age-denied]');
      if (denied) denied.hidden = false;
      this.querySelector('[data-age-accept]').hidden = true;
      this.querySelector('[data-age-decline]').hidden = true;
    }
  }

  if (!customElements.get('age-verifier')) {
    customElements.define('age-verifier', AgeVerifier);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      // Animate the block wrapper itself — see the note in the stylesheet
      // about `display: contents` freezing animation clocks. Every block
      // type (message, timer, ...) renders as a direct child of the group,
      // so walk the group's children rather than a single block type's
      // class — otherwise non-message blocks never receive `data-active`
      // and stay permanently invisible (opacity: 0 by default).
      const group = this.querySelector('[data-announcement-group]');
      this.messages = group ? Array.from(group.children) : [];
      if (this.messages.length === 0) return;

      if (this.dataset.mode === 'scroll') {
        this.setupScroll();
        return;
      }

      this.index = 0;
      this.show(0);

      /* Hands the first-message styling over to `data-active`. Set after
         show() so there is never a frame where neither rule applies. */
      this.setAttribute('data-ready', '');

      if (this.messages.length < 2) return;

      const prev = this.querySelector('[data-announcement-prev]');
      const next = this.querySelector('[data-announcement-next]');
      if (prev) prev.addEventListener('click', () => { this.step(-1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.step(1); this.restart(); });

      this.speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      if (this.autoplay) this.start();

      // Pause while the visitor is reading it.
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => { if (this.autoplay) this.start(); });
    }

    disconnectedCallback() {
      this.stop();
      this.resizeObserver?.disconnect();
      clearTimeout(this.fillTimer);
    }

    /**
     * Repeat the message group so the marquee loops without a visible gap.
     * The copies repeat content already announced, so they are hidden from
     * assistive technology and taken out of the tab order.
     */
    setupScroll() {
      const track = this.querySelector('[data-announcement-track]');
      const group = this.querySelector('[data-announcement-group]');
      const window_ = track ? track.parentElement : null;
      if (!track || !group || !window_) return;

      this.fillTrack = () => {
        // Count from one group every time, so a resize re-measures rather
        // than piling copies onto the copies made at the last width.
        track.querySelectorAll('[data-announcement-copy]').forEach((copy) => copy.remove());

        const groupWidth = group.getBoundingClientRect().width;
        if (!groupWidth) return;

        // A single copy is what used to leave the bar empty: the loop jumps
        // back after travelling one group's width, so the row has to stay
        // filled a whole group past the right-hand edge. Anything less and
        // the tail of the row runs out mid-loop and the bar reads blank
        // until it snaps back.
        const copies = Math.ceil(window_.clientWidth / groupWidth) + 1;

        for (let i = 0; i < copies; i += 1) {
          const copy = group.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('data-announcement-copy', '');
          copy.removeAttribute('data-announcement-group');
          copy.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          track.appendChild(copy);

          // A copied countdown is a photograph of the original — start it,
          // or it sits frozen a second behind and the mismatch is the first
          // thing the eye catches.
          if (window.PixelBearTimers) window.PixelBearTimers.init(copy);
        }

        // However many copies that took, the loop travels exactly one group.
        track.style.setProperty('--marquee-distance', `${groupWidth}px`);
      };

      this.fillTrack();

      // How many copies it takes changes with the width of the bar, and the
      // group's own width changes when a web font finally loads.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          clearTimeout(this.fillTimer);
          this.fillTimer = setTimeout(this.fillTrack, 150);
        });
        this.resizeObserver.observe(window_);
      }
    }

    show(index) {
      const leaving = this.messages.findIndex((m) => m.hasAttribute('data-active'));
      if (leaving === index) return;

      this.messages.forEach((message, i) => {
        message.toggleAttribute('data-active', i === index);
        message.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        if (i !== leaving) message.removeAttribute('data-leaving');
      });

      if (leaving === -1) return;

      // Keep the outgoing message painted until its transition finishes.
      const outgoing = this.messages[leaving];
      outgoing.setAttribute('data-leaving', '');
      clearTimeout(outgoing.leaveTimer);
      outgoing.leaveTimer = setTimeout(() => outgoing.removeAttribute('data-leaving'), 400);
    }

    step(delta) {
      this.index = (this.index + delta + this.messages.length) % this.messages.length;
      this.show(this.index);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.step(1), this.speed);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      if (this.autoplay) this.start();
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-drawer-close]')) {
          this.close();
          return;
        }

        const qtyButton = event.target.closest('[data-cart-qty]');
        if (qtyButton) {
          this.changeLine(qtyButton.dataset.line, qtyButton.dataset.cartQty);
          return;
        }

        const shippingSubmit = event.target.closest('[data-shipping-submit]');
        if (shippingSubmit) {
          this.calculateShipping();
          return;
        }

        const recommendationAdd = event.target.closest('[data-recommendation-add]');
        if (recommendationAdd) {
          this.addRecommendation(recommendationAdd.dataset.variantId, recommendationAdd);
          return;
        }

        const recommendationPrev = event.target.closest('[data-recommendation-prev]');
        if (recommendationPrev) {
          this.stepRecommendation(-1);
          return;
        }

        const recommendationNext = event.target.closest('[data-recommendation-next]');
        if (recommendationNext) {
          this.stepRecommendation(1);
        }
      });

      this.addEventListener('submit', (event) => {
        const discountForm = event.target.closest('[data-discount-form]');
        if (discountForm) {
          event.preventDefault();
          this.applyDiscount(discountForm);
        }
      });

      this.addEventListener('change', (event) => {
        const countrySelect = event.target.closest('[data-shipping-country]');
        if (countrySelect) this.updateProvinces(countrySelect);
      });

      // Header cart icon opens the drawer instead of navigating.
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-cart-drawer-trigger]');
        if (!trigger) return;
        event.preventDefault();
        this.open();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      document.addEventListener('cart-drawer:open', () => this.open());

      // Another component changed the cart and already has the fresh markup.
      document.addEventListener('cart-drawer:render', (event) => {
        if (event.detail) this.render(event.detail);
      });
    }

    open() {
      this.hidden = false;
      document.body.classList.add('scroll-locked');
      const closeButton = this.querySelector('.cart-drawer__close');
      if (closeButton) closeButton.focus();
      this.loadRecommendations();
    }

    close() {
      this.hidden = true;
      document.body.classList.remove('scroll-locked');
    }

    async changeLine(line, quantity) {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity),
          sections: this.sectionId,
        }),
      });

      if (!response.ok) return;

      const data = await response.json();
      this.render(data);
    }

    render(data) {
      const markup = data.sections && data.sections[this.sectionId];

      if (markup) {
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const fresh = parsed.querySelector('cart-drawer');
        if (fresh) this.innerHTML = fresh.innerHTML;
      }

      // `change.js` answers with the whole cart, `add.js` with just the line
      // that was added — so the count is only sometimes in hand. Either way
      // the recommendations seed (the first line item) can have changed, so
      // they're reloaded regardless of which branch updates the count.
      if (typeof data.item_count === 'number') {
        this.updateCount(data.item_count);
      } else {
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => response.json())
          .then((cart) => this.updateCount(cart.item_count))
          .catch(() => {});
      }

      this.loadRecommendations();
    }

    // Shopify has no cart-wide discount-application endpoint that covers
    // every discount type without going through checkout. The standard,
    // reliable pattern is a plain navigation to /discount/{code}, which
    // applies the code to the session and redirects back to the cart.
    applyDiscount(form) {
      const input = form.querySelector('[data-discount-input]');
      const error = form.querySelector('[data-discount-error]');
      const code = input ? input.value.trim() : '';

      if (!code) {
        if (error) error.hidden = false;
        return;
      }

      if (error) error.hidden = true;
      window.location.href = `${window.Shopify.routes.root}discount/${encodeURIComponent(code)}?redirect=%2Fcart`;
    }

    updateProvinces(countrySelect) {
      const option = countrySelect.options[countrySelect.selectedIndex];
      const provinceSelect = this.querySelector('[data-shipping-province]');
      if (!provinceSelect) return;

      let provinces = [];
      try {
        provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
      } catch (error) {
        provinces = [];
      }

      provinceSelect.innerHTML = '';

      if (!provinces.length) {
        provinceSelect.hidden = true;
        return;
      }

      provinces.forEach((province) => {
        const opt = document.createElement('option');
        [opt.value, opt.textContent] = province;
        provinceSelect.appendChild(opt);
      });
      provinceSelect.hidden = false;
    }

    async calculateShipping() {
      const results = this.querySelector('[data-shipping-results]');
      const countrySelect = this.querySelector('[data-shipping-country]');
      const provinceSelect = this.querySelector('[data-shipping-province]');
      const zipInput = this.querySelector('[data-shipping-zip]');
      if (!results || !countrySelect) return;

      const country = countrySelect.value;
      const province = provinceSelect && !provinceSelect.hidden ? provinceSelect.value : '';
      const zip = zipInput ? zipInput.value.trim() : '';

      if (!country || !zip) {
        results.innerHTML = `<p>${this.dataset.shippingEmptyText || ''}</p>`;
        return;
      }

      const params = new URLSearchParams({
        'shipping_address[zip]': zip,
        'shipping_address[country]': country,
      });
      if (province) params.set('shipping_address[province]', province);

      results.innerHTML = '';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?${params.toString()}`, {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) throw new Error(`Shipping rates failed: ${response.status}`);

        const data = await response.json();
        const rates = data.shipping_rates || [];

        if (!rates.length) {
          results.innerHTML = `<p>${this.dataset.shippingNoRatesText || ''}</p>`;
          return;
        }

        results.innerHTML = rates
          .map(
            (rate) => `
              <p class="cart-drawer__shipping-rate">
                <span>${this.escapeHtml(rate.presentment_name || rate.name)}</span>
                <span>${this.formatMoney(rate.price)}</span>
              </p>
            `
          )
          .join('');
      } catch (error) {
        results.innerHTML = `<p>${this.dataset.shippingErrorText || ''}</p>`;
      }
    }

    // The drawer isn't a single-product context, so the first line item's
    // product seeds Shopify's recommendations endpoint for a cross-sell row.
    loadRecommendations() {
      const container = this.querySelector('[data-cart-recommendations]');
      if (!container || !container.dataset.url) return;

      fetch(container.dataset.url, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => this.renderRecommendations(container, (data && data.products) || []))
        .catch(() => {
          container.hidden = true;
        });
    }

    renderRecommendations(container, products) {
      const list = container.querySelector('[data-cart-recommendations-list]');
      if (!list) return;

      // A previous render's timer must not keep advancing a list that's
      // about to be replaced (or torn down entirely, if there are no
      // results this time).
      clearInterval(this.recommendationsTimer);

      if (!products.length) {
        container.hidden = true;
        list.innerHTML = '';
        return;
      }

      list.innerHTML = products
        .slice(0, 4)
        .map((product) => {
          const variant = product.variants && product.variants[0];
          const image = product.featured_image || (product.images && product.images[0]) || '';
          const price = this.formatMoney(variant ? variant.price : product.price);

          return `
            <li class="cart-drawer__recommendation">
              <a href="${product.url}" class="cart-drawer__recommendation-media media media--square">
                ${image ? `<img src="${image}" loading="lazy" alt="${this.escapeHtml(product.title)}">` : ''}
              </a>
              <div class="cart-drawer__recommendation-info">
                <a href="${product.url}" class="cart-drawer__recommendation-title">${this.escapeHtml(product.title)}</a>
                <span class="cart-drawer__recommendation-price">${price}</span>
              </div>
              ${
                variant
                  ? `<button type="button" class="cart-drawer__recommendation-add" data-recommendation-add data-variant-id="${variant.id}" aria-label="${this.dataset.addToCartText || '+'}">
                      <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">
                        <path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </button>`
                  : ''
              }
            </li>
          `;
        })
        .join('');

      container.hidden = false;

      // One product shown at a time, sliding to the next every 2s and
      // looping back to the first after the last — a lightweight carousel
      // driven by a plain transform rather than scroll-snap, since nothing
      // here needs to be user-draggable.
      this.recommendationsIndex = 0;
      this.showRecommendation(0);
      if (list.children.length > 1) this.startRecommendationsAutoplay();
    }

    // Always re-queries the live list rather than trusting a reference
    // cached at render time: open() and render() can both call
    // loadRecommendations() in close succession (e.g. right after adding an
    // item both opens the drawer and re-renders it), and if a cached
    // reference survived from a render that's since been replaced via
    // innerHTML, the prev/next arrows would silently update a detached
    // element nobody can see instead of the one on screen.
    showRecommendation(index) {
      const list = this.querySelector('[data-cart-recommendations-list]');
      const count = list ? list.children.length : 0;
      if (!list || !count) return;

      this.recommendationsIndex = ((index % count) + count) % count;

      // clientWidth is the list's own already-resolved rendered width in
      // plain pixels — not a CSS transform percentage that has to be
      // computed against a box whose size depends on how the surrounding
      // flex layout got resolved. Native scrolling (scroll-snap-type on the
      // list, scroll-snap-align on each slide) does the actual positioning
      // and animation, rather than a hand-rolled transform.
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rtl = getComputedStyle(list).direction === 'rtl';
      list.scrollTo({
        left: list.clientWidth * this.recommendationsIndex * (rtl ? -1 : 1),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    startRecommendationsAutoplay() {
      clearInterval(this.recommendationsTimer);
      this.recommendationsTimer = setInterval(() => this.stepRecommendation(1), 2000);
    }

    // Shared by both the auto-advance timer and the prev/next arrows. A
    // manual step restarts the 2s timer rather than letting it fire right
    // on top of the click, which would otherwise skip straight past the
    // slide the visitor just chose to look at.
    stepRecommendation(direction) {
      this.showRecommendation(this.recommendationsIndex + direction);
      this.startRecommendationsAutoplay();
    }

    async addRecommendation(variantId, button) {
      if (!variantId) return;

      button.disabled = true;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: this.sectionId,
          }),
        });

        if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);

        const data = await response.json();
        this.render(data);
      } catch (error) {
        // Leave the drawer as-is; the shopper can retry.
      } finally {
        button.disabled = false;
      }
    }

    formatMoney(cents) {
      const amount = Number(cents) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2);
      }
    }

    escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    }

    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        // Write into the hidden label, not over the element: the dot is the
        // element itself, and replacing its contents would put a digit back
        // inside it and drop the text assistive tech reads.
        const value = el.querySelector('[data-cart-count-value]') || el;
        value.textContent = count;
        el.hidden = count === 0;
      });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cart-qty]');
        if (!button) return;
        this.change(button.dataset.line, button.dataset.cartQty);
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quantity-input]');
        if (!input) return;
        this.change(input.dataset.line, input.value);
      });
    }

    async change(line, quantity) {
      this.setAttribute('data-loading', '');

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: Number(line),
            quantity: Number(quantity),
            sections: this.sectionId,
          }),
        });

        if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);

        const data = await response.json();
        const markup = data.sections && data.sections[this.sectionId];

        if (markup) {
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const fresh = parsed.querySelector('cart-page');
          if (fresh) this.innerHTML = fresh.innerHTML;
        }

        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          const value = el.querySelector('[data-cart-count-value]') || el;
          value.textContent = data.item_count;
          el.hidden = data.item_count === 0;
        });
      } catch (error) {
        // Fall back to a full page load so the shopper still sees the truth.
        window.location.reload();
      } finally {
        this.removeAttribute('data-loading');
      }
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
  /**
   * Drifts cells against the page as it scrolls.
   *
   * Only cells that asked for it are tracked, and only while the section is on
   * screen — a canvas of still cells costs nothing. Offsets are written inside
   * a rAF callback so a burst of scroll events collapses into one write.
   */
  class DynamicGrid extends HTMLElement {
    connectedCallback() {
      this.cells = Array.from(this.querySelectorAll('[data-parallax]'));
      if (this.cells.length === 0) return;

      this.onScroll = () => this.request();
      window.addEventListener('scroll', this.onScroll, { passive: true });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.request();
        });
        this.observer.observe(this);
      } else {
        this.visible = true;
      }

      this.request();
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.observer) this.observer.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    request() {
      if (this.frame || this.visible === false) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const rect = this.getBoundingClientRect();
        // -0.5 to 0.5 across the section's travel through the viewport.
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height) - 0.5;

        this.cells.forEach((cell) => {
          const speed = Number(cell.dataset.parallax) || 0;
          cell.style.setProperty('--cell-drift', `${progress * speed * -2}vh`);
        });
      });
    }
  }

  if (!customElements.get('dynamic-grid')) {
    customElements.define('dynamic-grid', DynamicGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Appends the next page of products in place, for the "Load more" and
     "Infinite scrolling" modes. The markup it upgrades is a plain link to the
     next page, so the collection is still fully browsable if this never runs. */
  class CollectionPaginator extends HTMLElement {
    connectedCallback() {
      /* The parser connects a custom element as soon as its opening tag is
         read, which can be before its own children exist. Waiting for the
         button to be there keeps the setup below from binding to nothing. */
      if (!this.querySelector('[data-load-more]')) {
        // isConnected guards the retry against an element taken back out of
        // the page (a filter re-render) before its children ever arrived.
        requestAnimationFrame(() => {
          if (this.isConnected) this.connectedCallback();
        });
        return;
      }
      if (this.ready) return;
      this.ready = true;

      this.button = this.querySelector('[data-load-more]');
      this.status = this.querySelector('[data-status]');
      this.loading = false;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.loadNext();
      });

      if (this.dataset.mode === 'infinite') this.startAuto();
    }

    disconnectedCallback() {
      this.stopAuto();
    }

    /* Measured against the scroll position rather than watched with an
       IntersectionObserver. An observer reports only *changes* in
       intersection, so once the foot of the grid was inside the margin it
       stayed there and no further callback arrived — the load stalled after
       one page, or never began when the element was already in range as the
       page opened. A plain measurement has no such state: it answers the same
       question correctly every time it is asked. */
    startAuto() {
      this.setAttribute('data-auto', '');

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.maybeLoad();
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      // The foot of a short collection can already be in range on arrival.
      this.maybeLoad();
    }

    stopAuto() {
      if (!this.onScroll) return;
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.onScroll = null;
    }

    /* Fetches before the foot of the grid is actually reached, so the next
       products are usually already in place by the time they are scrolled to
       rather than after a visible wait at the bottom. */
    maybeLoad() {
      if (this.loading || !this.dataset.nextUrl) return;
      if (this.getBoundingClientRect().top - window.innerHeight < 600) this.loadNext();
    }

    async loadNext() {
      const url = this.dataset.nextUrl;
      if (!url || this.loading) return;

      this.loading = true;
      this.setAttribute('data-loading', '');
      if (this.status) this.status.textContent = this.dataset.loadingText || '';

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = document.querySelector(this.dataset.grid);
        const incoming = doc.querySelector(this.dataset.grid);
        if (!grid || !incoming) throw new Error('Grid not found in response');

        grid.append(...incoming.children);

        /* The fetched page carries its own paginator, which knows what comes
           after it. Taking the next URL from there is what walks the pages on;
           its absence is how the end of the collection is recognised. */
        const next = doc.querySelector('collection-paginator')?.dataset.nextUrl;
        if (next) {
          this.dataset.nextUrl = next;
          this.button.href = next;
          if (this.status) this.status.textContent = '';
        } else {
          this.stopAuto();
          this.remove();
        }
      } catch (error) {
        /* Put the button back and leave its link pointing where it did: a
           visitor can still follow it to the next page as an ordinary
           navigation. */
        this.stopAuto();
        this.removeAttribute('data-auto');
        if (this.status) this.status.textContent = '';
      } finally {
        this.loading = false;
        this.removeAttribute('data-loading');
      }

      /* The page just added may not reach past the fold — a short last page,
         or a tall screen. Asking again once it has been laid out keeps a run
         of short pages going instead of stopping after the first. */
      if (this.onScroll) requestAnimationFrame(() => this.maybeLoad());
    }
  }

  if (!customElements.get('collection-paginator')) {
    customElements.define('collection-paginator', CollectionPaginator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    
  class CookieBanner extends HTMLElement {
    connectedCallback() {
      if (window.Shopify && window.Shopify.designMode) return;

      this.querySelector('[data-cookie-accept]').addEventListener('click', () => this.respond(true));
      this.querySelector('[data-cookie-decline]').addEventListener('click', () => this.respond(false));

      // The privacy API loads asynchronously; wait for it before deciding.
      document.addEventListener('visitorConsentCollected', () => this.hide());
      this.waitForApi().then(() => this.maybeShow());
    }

    waitForApi() {
      return new Promise((resolve) => {
        if (window.Shopify && window.Shopify.customerPrivacy) return resolve();
        let tries = 0;
        const timer = setInterval(() => {
          tries += 1;
          if ((window.Shopify && window.Shopify.customerPrivacy) || tries > 40) {
            clearInterval(timer);
            resolve();
          }
        }, 250);
      });
    }

    maybeShow() {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return;

      try {
        // Only ask where consent is actually required and not yet given.
        if (privacy.shouldShowBanner && !privacy.shouldShowBanner()) return;
        this.hidden = false;
      } catch (error) {
        /* If the API misbehaves, stay quiet rather than nagging. */
      }
    }

    respond(accepted) {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;

      if (privacy && privacy.setTrackingConsent) {
        privacy.setTrackingConsent(
          {
            analytics: accepted,
            marketing: accepted,
            preferences: accepted,
            sale_of_data: accepted,
          },
          () => this.hide()
        );
      } else {
        this.hide();
      }
    }

    hide() {
      this.hidden = true;
    }
  }

  if (!customElements.get('cookie-banner')) {
    customElements.define('cookie-banner', CookieBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-condensed"] && !Shopify.designMode) return;
  try {
    
  class CountdownCondensed extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (Number.isNaN(end)) return;

      this.end = end;
      this.clock = this.querySelector('[data-countdown-clock]');
      this.expired = this.querySelector('[data-countdown-expired]');
      this.fields = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = this.end - Date.now();

      if (remaining <= 0) {
        clearInterval(this.timer);
        this.finish();
        return;
      }

      const seconds = Math.floor(remaining / 1000);
      this.fields.days.textContent = Math.floor(seconds / 86400);
      this.fields.hours.textContent = String(Math.floor((seconds % 86400) / 3600)).padStart(2, '0');
      this.fields.minutes.textContent = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      this.fields.seconds.textContent = String(seconds % 60).padStart(2, '0');
    }

    finish() {
      if (this.dataset.hideWhenDone === 'true') {
        this.hidden = true;
        return;
      }
      if (this.clock) this.clock.hidden = true;
      if (this.expired) this.expired.hidden = false;
    }
  }

  if (!customElements.get('countdown-condensed')) {
    customElements.define('countdown-condensed', CountdownCondensed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (Number.isNaN(end)) return;

      this.end = end;
      this.timerEl = this.querySelector('[data-countdown-timer]');
      this.expiredEl = this.querySelector('[data-countdown-expired]');
      this.fields = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const remaining = this.end - Date.now();

      if (remaining <= 0) {
        clearInterval(this.interval);
        this.complete();
        return;
      }

      const total = Math.floor(remaining / 1000);
      const pad = (n) => String(n).padStart(2, '0');

      this.fields.days.textContent = pad(Math.floor(total / 86400));
      this.fields.hours.textContent = pad(Math.floor((total % 86400) / 3600));
      this.fields.minutes.textContent = pad(Math.floor((total % 3600) / 60));
      this.fields.seconds.textContent = pad(total % 60);
    }

    complete() {
      if (this.dataset.onComplete === 'hide') {
        this.hidden = true;
        return;
      }
      if (this.timerEl) this.timerEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  (function () {
    // Show/hide the new-address and edit-address forms.
    document.querySelectorAll('[data-address-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = document.getElementById(button.dataset.addressToggle);
        if (!target) return;
        target.hidden = !target.hidden;
        if (!target.hidden) {
          const field = target.querySelector('input, select');
          if (field) field.focus();
        }
      });
    });

    /**
     * Populate the province select from the chosen country.
     *
     * `all_country_option_tags` puts the province list on each <option> as a
     * data-provinces JSON array, so this needs no external script. Countries
     * with no provinces keep their container hidden.
     */
    function wireCountrySelect(countrySelect) {
      const suffix = countrySelect.id.replace('AddressCountry', '');
      const container = document.getElementById(`AddressProvinceContainer${suffix}`);
      const provinceSelect = document.getElementById(`AddressProvince${suffix}`);
      if (!container || !provinceSelect) return;

      function update(preserveDefault) {
        const option = countrySelect.options[countrySelect.selectedIndex];
        let provinces = [];

        try {
          provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
        } catch (error) {
          provinces = [];
        }

        provinceSelect.innerHTML = '';

        if (provinces.length === 0) {
          container.style.display = 'none';
          return;
        }

        provinces.forEach((province) => {
          const opt = document.createElement('option');
          opt.value = province[0];
          opt.textContent = province[1];
          provinceSelect.appendChild(opt);
        });

        if (preserveDefault && provinceSelect.dataset.default) {
          provinceSelect.value = provinceSelect.dataset.default;
        }

        container.style.display = '';
      }

      if (countrySelect.dataset.default) {
        countrySelect.value = countrySelect.dataset.default;
      }

      update(true);
      countrySelect.addEventListener('change', () => update(false));
    }

    document
      .querySelectorAll('select[id^="AddressCountry"]')
      .forEach(wireCountrySelect);

    // Deleting an address is a POST with a _method override.
    document.querySelectorAll('[data-address-delete]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!window.confirm(button.dataset.confirm)) return;

        const form = document.createElement('form');
        form.method = 'post';
        form.action = button.dataset.url;

        const method = document.createElement('input');
        method.type = 'hidden';
        method.name = '_method';
        method.value = 'delete';
        form.appendChild(method);

        document.body.appendChild(form);
        form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-login"]) return;
  try {
    
  // Swap between the sign-in and password-recovery panels.
  (function () {
    const login = document.getElementById('CustomerLogin');
    const recover = document.getElementById('RecoverPassword');
    if (!login || !recover) return;

    function toggle() {
      const showRecover = recover.hidden;
      recover.hidden = !showRecover;
      login.hidden = showRecover;
      const focusTarget = showRecover
        ? recover.querySelector('input')
        : login.querySelector('input');
      if (focusTarget) focusTarget.focus();
    }

    document.querySelectorAll('[data-toggle-recover]').forEach((button) => {
      button.addEventListener('click', toggle);
    });

    // Deep link support: /account/login#recover opens the recovery form.
    if (window.location.hash === '#recover') toggle();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollections extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.bindRails();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });

      // The "View all" on the tab line belongs to the collection showing.
      this.querySelectorAll('[data-view-all]').forEach((link) => {
        link.hidden = Number(link.dataset.viewAll) !== index;
      });

      // A panel measured while hidden reports no size, so size its rail now
      // that it is visible.
      this.updateRail(this.panels[index]);
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;

      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (next === null) return;

      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }

    bindRails() {
      this.querySelectorAll('.featured-collections__panel').forEach((panel) => {
        const track = panel.querySelector('[data-product-track]');
        if (!track || !panel.querySelector('[data-scroll-thumb]')) return;

        track.addEventListener('scroll', () => this.updateRail(panel), { passive: true });
        this.updateRail(panel);

        /* A page at a time, measured off the track rather than a card: the
           card count per row changes with the breakpoint. scrollBy is in
           physical pixels, so under RTL the direction has to be flipped. */
        const prev = panel.querySelector('[data-scroll-prev]');
        const next = panel.querySelector('[data-scroll-next]');
        const step = (sign) => {
          const rtl = getComputedStyle(track).direction === 'rtl';
          track.scrollBy({ left: sign * track.clientWidth * 0.9 * (rtl ? -1 : 1), behavior: 'smooth' });
        };
        if (prev) prev.addEventListener('click', () => step(-1));
        if (next) next.addEventListener('click', () => step(1));
      });

      this.onResize = () => {
        this.querySelectorAll('.featured-collections__panel').forEach((panel) => this.updateRail(panel));
      };
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    updateRail(panel) {
      if (!panel) return;
      const track = panel.querySelector('[data-product-track]');
      const thumb = panel.querySelector('[data-scroll-thumb]');
      if (!track || !thumb) return;

      const scrollable = track.scrollWidth - track.clientWidth;
      const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;

      thumb.style.width = `${Math.min(ratio, 1) * 100}%`;
      const progress = scrollable > 0 ? Math.abs(track.scrollLeft) / scrollable : 0;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const travel = progress * (100 / Math.min(ratio, 1) - 100) * (rtl ? -1 : 1);
      thumb.style.transform = `translateX(${travel}%)`;
    }
  }

  if (!customElements.get('featured-collections')) {
    customElements.define('featured-collections', FeaturedCollections);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-links"] && !Shopify.designMode) return;
  try {
    
  /**
   * Floats the hovered link's image alongside the pointer.
   *
   * Position is written to custom properties inside a rAF callback so several
   * pointer events in one frame collapse into a single style write.
   */
  class FeaturedLinks extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'reveal') return;

      this.list = this.querySelector('.featured-links__list');
      this.cursor = this.querySelector('[data-links-cursor]');
      this.image = this.querySelector('[data-links-cursor-image]');
      if (!this.list || !this.cursor || !this.image) return;

      // Sources are read off the links themselves, so nothing has to be
      // duplicated into the cursor markup.
      this.sources = new Map();
      this.list.querySelectorAll('.featured-link').forEach((link) => {
        const img = link.querySelector('.featured-link__image');
        if (img) this.sources.set(link, img.currentSrc || img.src);
      });

      if (this.sources.size === 0) return;

      this.onMove = (event) => this.track(event);
      this.onLeave = () => this.hide();

      this.list.addEventListener('pointermove', this.onMove);
      this.list.addEventListener('pointerleave', this.onLeave);
    }

    disconnectedCallback() {
      if (this.list && this.onMove) {
        this.list.removeEventListener('pointermove', this.onMove);
        this.list.removeEventListener('pointerleave', this.onLeave);
      }
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    track(event) {
      const link = event.target.closest('.featured-link');
      const source = link && this.sources.get(link);

      if (!source) {
        this.hide();
        return;
      }

      if (this.image.getAttribute('src') !== source) {
        this.image.setAttribute('src', source);
      }

      const bounds = this.querySelector('.featured-links__inner').getBoundingClientRect();
      this.point = { x: event.clientX - bounds.left, y: event.clientY - bounds.top };

      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.cursor.style.setProperty('--cursor-x', `${this.point.x}px`);
        this.cursor.style.setProperty('--cursor-y', `${this.point.y}px`);
        this.cursor.setAttribute('data-visible', '');
      });
    }

    hide() {
      this.cursor.removeAttribute('data-visible');
    }
  }

  if (!customElements.get('featured-links')) {
    customElements.define('featured-links', FeaturedLinks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Header behaviour.
   *
   * A custom element rather than a one-time script: the theme editor and the
   * section rendering API replace this markup, and anything bound once on load
   * is lost the moment that happens — the menus would work on first paint and
   * then stop responding.
   *
   * Document-level listeners are tracked so they can be detached when the
   * element goes away, otherwise each re-render would stack another copy.
   */
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.onDocumentClick = (event) => {
        // The drawer panel is a sibling of <details data-header-drawer>, not
        // a descendant of it (see the markup comment on
        // [data-drawer-panel]), so a click inside the panel itself would
        // otherwise .closest() past it and register as an outside click,
        // closing the drawer the moment anything inside it — a menu link,
        // even just the panel background — is clicked.
        const toggle = event.target.closest('[data-header-dropdown], [data-header-drawer]');
        const insidePanel = event.target.closest('[data-drawer-panel]');
        this.closeAll(toggle || (insidePanel ? this.querySelector('[data-header-drawer]') : null));
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.closeAll(null);
      };

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);

      this.bindHover();
      this.bindDrawer();
      this.publishHeight();
      this.bindStickyState();
      this.bindTransparency();
      this.bindHideOnScroll();
    }

    /**
     * While the drawer covers the screen the page behind it must not scroll,
     * and reopening it should start at the top level rather than wherever the
     * visitor last drilled down to.
     */
    bindDrawer() {
      const drawer = this.querySelector('[data-header-drawer]');
      const panel = this.querySelector('[data-drawer-panel]');
      if (!drawer || !panel) return;

      // The panel covers the whole viewport now, so there is nothing left to
      // anchor it beneath — the measuring that used to set --drawer-top on
      // open and on resize went with it.
      panel.querySelector('[data-drawer-close]')?.addEventListener('click', () => {
        drawer.removeAttribute('open');
      });

      // The panel is a sibling of <details>, not a child of it — see the
      // markup comment — so its visibility is driven from here rather than
      // by the disclosure's own [open] state.
      drawer.addEventListener('toggle', () => {
        document.body.classList.toggle('drawer-open', drawer.open);
        panel.hidden = !drawer.open;

        if (drawer.open) return;

        const nav = panel.querySelector('[data-drawer-nav]');
        if (nav) nav.show('root');
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onStickScroll) window.removeEventListener('scroll', this.onStickScroll);
      if (this.onSectionChange) {
        document.removeEventListener('shopify:section:load', this.onSectionChange);
        document.removeEventListener('shopify:section:unload', this.onSectionChange);
      }
      if (this.resizeObserver) this.resizeObserver.disconnect();
      clearTimeout(this.closeTimer);
    }

    closeAll(except) {
      this.querySelectorAll('[data-header-dropdown][open], [data-header-drawer][open]').forEach((el) => {
        if (el !== except) el.removeAttribute('open');
      });
    }

    bindHover() {
      if (this.dataset.openTrigger !== 'hover') return;
      if (!window.matchMedia('(hover: hover)').matches) return;

      // Delegated rather than bound per menu, because `mouseenter` does not
      // bubble: it only fires when the pointer crosses into that element's own
      // box. Moving sideways from an open menu to its neighbour can miss that
      // crossing — the pointer is already inside the bar — so the second menu
      // never heard it and would not open until the first had closed.
      // `pointerover` bubbles, so every move re-asks which menu is under it.
      this.onPointerOver = (event) => {
        const target = event.target.closest('[data-header-dropdown]');

        if (!target) {
          // Still inside the header but not over a menu: let the open one go,
          // after the same grace period the travel to a panel relies on.
          if (this.querySelector('[data-header-dropdown][open]')) this.scheduleClose();
          return;
        }

        clearTimeout(this.closeTimer);
        if (target.hasAttribute('open')) return;

        this.closeAll(target);
        target.setAttribute('open', '');
      };

      // The panel sits below the header, so the pointer briefly crosses the
      // header's own padding on the way to it. Closing immediately would
      // snatch the menu away mid-travel; wait out the gap.
      this.onPointerLeave = () => this.scheduleClose();

      this.addEventListener('pointerover', this.onPointerOver);
      this.addEventListener('pointerleave', this.onPointerLeave);
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this.querySelectorAll('[data-header-dropdown][open]').forEach((el) => {
          el.removeAttribute('open');
        });
      }, 220);
    }

    /** Publish the bar height so a transparent header can offset the page. */
    publishHeight() {
      const publish = () => {
        document.documentElement.style.setProperty(
          '--header-height',
          `${Math.round(this.getBoundingClientRect().height)}px`
        );
      };

      publish();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(publish);
        this.resizeObserver.observe(this);
      }
    }

    /**
     * Whether the header is currently stuck to the top of the viewport —
     * independent of transparency, since the sticky logo, sticky color
     * scheme, and the transparency effect below all key off this same
     * [data-stuck] attribute and sticky can be turned on without
     * transparency ever being enabled at all.
     */
    bindStickyState() {
      if (this.dataset.sticky !== 'true') return;

      this.onStickScroll = () => this.toggleAttribute('data-stuck', window.scrollY > 8);
      this.onStickScroll();
      window.addEventListener('scroll', this.onStickScroll, { passive: true });
    }

    bindTransparency() {
      /* Driven solely by the header's own "Enable transparent header"
         setting now — sections no longer carry their own
         [data-allow-transparent-header] opt-in, so there's nothing left to
         read from the page itself. The flag is still written to the body
         (rather than styling off the setting directly) so the CSS only has
         to read one attribute, and so re-checking after an editor re-render
         (below) stays trivial. */
      const apply = () => {
        const enabled = this.dataset.transparentHeaderEnabled === 'true';
        document.body.toggleAttribute('data-transparent-header', enabled);
        return enabled;
      };

      // The editor swaps section markup after this element is connected, so
      // the flag is re-checked whenever a section is redrawn.
      this.onSectionChange = () => apply();
      document.addEventListener('shopify:section:load', this.onSectionChange);
      document.addEventListener('shopify:section:unload', this.onSectionChange);

      apply();
    }

    bindHideOnScroll() {
      if (this.dataset.hideOnScroll !== 'true' || this.dataset.sticky !== 'true') return;

      let last = window.scrollY;

      this.onScroll = () => {
        const current = window.scrollY;
        const goingDown = current > last && current > this.offsetHeight;

        // Never hide while a menu is open.
        if (this.querySelector('[open]')) this.removeAttribute('data-hidden');
        else this.toggleAttribute('data-hidden', goingDown);

        last = current;
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /**
   * Before/after comparison cursor.
   *
   * Position lives in a custom property so the clip and the cursor stay in
   * step from one write, and the markup renders at the authored position with
   * no script involved.
   */
  class BeforeAfter extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-comparison-frame]');
      this.cursor = this.querySelector('[data-comparison-cursor]');
      if (!this.frame || !this.cursor) return;

      this.dragging = false;

      this.onPointerMove = (event) => {
        if (!this.dragging) return;
        event.preventDefault();
        this.setFromPoint(event);
      };
      this.onPointerUp = () => {
        this.dragging = false;
      };

      this.cursor.addEventListener('pointerdown', (event) => {
        this.dragging = true;
        this.cursor.setPointerCapture(event.pointerId);
      });
      this.frame.addEventListener('click', (event) => this.setFromPoint(event));
      this.cursor.addEventListener('keydown', (event) => this.onKeydown(event));

      window.addEventListener('pointermove', this.onPointerMove, { passive: false });
      window.addEventListener('pointerup', this.onPointerUp);
    }

    disconnectedCallback() {
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
    }

    get vertical() {
      return this.dataset.direction === 'vertical';
    }

    setFromPoint(event) {
      const rect = this.frame.getBoundingClientRect();
      const value = this.vertical
        ? ((event.clientY - rect.top) / rect.height) * 100
        : ((event.clientX - rect.left) / rect.width) * 100;

      this.set(value);
    }

    onKeydown(event) {
      const keys = {
        ArrowLeft: -2,
        ArrowDown: -2,
        ArrowRight: 2,
        ArrowUp: 2,
        Home: -100,
        End: 100,
      };
      if (!(event.key in keys)) return;

      event.preventDefault();
      const current = Number(this.cursor.getAttribute('aria-valuenow')) || 50;
      this.set(event.key === 'Home' || event.key === 'End' ? 50 + keys[event.key] : current + keys[event.key]);
    }

    set(value) {
      const clamped = Math.max(0, Math.min(100, value));
      this.style.setProperty('--cursor-position', `${clamped}%`);
      this.cursor.setAttribute('aria-valuenow', Math.round(clamped));
    }
  }

  if (!customElements.get('before-after')) {
    customElements.define('before-after', BeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  class LogoMarquee extends HTMLElement {
    connectedCallback() {
      // Only the marquee layout needs the duplicated track.
      if (!this.classList.contains('logo-list__layout--marquee')) return;

      this.track = this.querySelector('[data-marquee-track]');
      if (!this.track || this.track.children.length === 0) return;

      // connectedCallback runs again if the element is moved in the DOM, and
      // building twice would leave stale copies behind.
      if (this.built) return;
      this.built = true;

      this.build();

      // Logos and web fonts both settle after first paint and both change how
      // wide one pass is, so the track is measured again whenever it changes.
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.track);
      }

      this.onResize = () => this.build();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    /**
     * Lays down as many copies of the track as it takes to keep the row full.
     *
     * Each copy travels its own width, so the row only stays unbroken while
     * the copies trailing the first one can cover the viewport between them.
     * Two copies do that only when a single pass is already wider than the
     * screen; below that the row runs out and snaps back.
     */
    build() {
      const width = this.track.getBoundingClientRect().width;
      if (!width) return;

      const copies = Math.max(2, Math.ceil(window.innerWidth / width) + 1);
      if (this.copies === copies) return;
      this.copies = copies;

      this.querySelectorAll('[data-marquee-copy]').forEach((node) => node.remove());

      for (let i = 1; i < copies; i += 1) {
        // Visual duplicates only, so they are hidden from assistive technology
        // and taken out of the tab order.
        const clone = this.track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-marquee-copy', '');
        clone.removeAttribute('data-marquee-track');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        this.appendChild(clone);
      }
    }
  }

  if (!customElements.get('logo-marquee')) {
    customElements.define('logo-marquee', LogoMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-slider"] && !Shopify.designMode) return;
  try {
    
  class LookbookSliderCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lookbook-track]');
      this.prevButton = this.querySelector('[data-lookbook-prev]');
      this.nextButton = this.querySelector('[data-lookbook-next]');
      if (!this.track || !this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });

      // The track's own content (and so how far it can scroll) can change
      // after connect — recheck whenever it does, not just once at load.
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.updateArrows());
        this.observer.observe(this.track);
      }

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    // `scrollBy` is measured in physical pixels, so "next" is a negative
    // offset once the track reads right-to-left. scrollLeft counts the same
    // way — from 0 down into negative numbers — which is why the distance
    // travelled is read as an absolute value below.
    #rtl() {
      return getComputedStyle(this.track).direction === 'rtl';
    }

    scrollByCard(direction) {
      const card = this.track.children[0];
      if (!card) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: card.getBoundingClientRect().width * direction * (this.#rtl() ? -1 : 1),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrolled = Math.abs(this.track.scrollLeft);
      const atStart = scrolled <= 1;
      const atEnd = scrolled >= maxScroll - 1;

      this.prevButton.hidden = atStart;
      this.nextButton.hidden = atEnd;

      // Nothing to scroll at all — hide both rather than showing a disabled
      // pair of arrows that will never do anything.
      if (maxScroll <= 1) {
        this.prevButton.hidden = true;
        this.nextButton.hidden = true;
      }
    }
  }

  if (!customElements.get('lookbook-slider-carousel')) {
    customElements.define('lookbook-slider-carousel', LookbookSliderCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
  /**
   * Copies the gift card code, and says so on the button that was pressed.
   *
   * The clipboard API needs a secure context and can be refused, so a failure
   * falls back to selecting the code in its field for the visitor to copy.
   */
  class GiftCardCopy extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-copy-button]');
      if (!this.button) return;

      this.original = this.dataset.label || this.button.textContent.trim();
      this.button.addEventListener('click', () => this.#copy());
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    async #copy() {
      const code = this.dataset.code || '';

      try {
        await navigator.clipboard.writeText(code);
        this.#confirm();
      } catch {
        // Nothing was copied, so hand the visitor the selected text instead
        // of claiming success on a button they pressed.
        const field = this.closest('.gift-card-page__redeem')?.querySelector('.gift-card-page__code');
        field?.select();
      }
    }

    #confirm() {
      // The label may have been paired with a hidden copy for the button
      // animation; both have to change or the swap shows the old word.
      this.#write(this.dataset.copied || this.original);
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.#write(this.original), 2000);
    }

    #write(value) {
      // Once enhanced the label is two stacked copies, and both have to change
      // or the swap animation reveals the word that was replaced.
      const copies = this.button.querySelectorAll('.button__label-track > span');

      if (copies.length) {
        copies.forEach((copy) => {
          copy.textContent = value;
        });
      } else {
        this.button.textContent = value;
      }
    }
  }

  if (!customElements.get('gift-card-copy')) {
    customElements.define('gift-card-copy', GiftCardCopy);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-print-button]')) window.print();
  });

  /**
   * Draws the QR code once Shopify's encoder has loaded. The script is
   * deferred, so the element may be in the document before QRCode exists.
   */
  (() => {
    const draw = () => {
      const target = document.querySelector('[data-qr-code]');
      if (!target || !window.QRCode || target.childElementCount) return;

      new window.QRCode(target, {
        text: target.dataset.qrValue,
        width: 120,
        height: 120,
        colorDark: getComputedStyle(target).color,
        colorLight: 'rgba(0,0,0,0)',
        // The highest error-correction level packs the most modules into the
        // same square, so each one is finer. It also carries the most
        // redundancy, so the denser code stays the easiest to read back.
        correctLevel: window.QRCode.CorrectLevel.H,
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', draw);
    } else {
      draw();
    }
    window.addEventListener('load', draw);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * Moves the product row and keeps the dots in step.
   *
   * Position is read back from the scroller rather than counted, so dragging
   * the row by hand keeps the dots honest.
   */
  class ProductsWithImage extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-product-track]');
      if (!this.track) return;

      this.dots = Array.from(this.querySelectorAll('[data-scroll-to]'));

      const prev = this.querySelector('[data-scroll-prev]');
      const next = this.querySelector('[data-scroll-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.scrollTo)));
      });

      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
      this.#placeArrows();

      // The picture's height arrives late — a lazy image loads, a web font
      // re-flows the name under it, the column changes width — so the line is
      // re-measured rather than worked out once.
      if ('ResizeObserver' in window) {
        this.arrowObserver = new ResizeObserver(() => this.#placeArrows());
        this.arrowObserver.observe(this.track);
      }
    }

    disconnectedCallback() {
      this.arrowObserver?.disconnect();
    }

    /** Puts the arrows on the centre line of the card's picture. */
    #placeArrows() {
      const viewport = this.querySelector('.carousel-viewport');
      const card = this.track.firstElementChild;
      const media = card?.querySelector('.product-card__media');
      if (!viewport || !media) return;

      const mediaBox = media.getBoundingClientRect();
      if (!mediaBox.height) return;

      const top = mediaBox.top + mediaBox.height / 2 - viewport.getBoundingClientRect().top;
      viewport.style.setProperty('--pwi-arrow-top', `${Math.round(top)}px`);
    }

    get cards() {
      return Array.from(this.track.children);
    }

    step(direction) {
      this.goTo(this.current + direction);
    }

    get current() {
      const cards = this.cards;
      if (cards.length === 0) return 0;
      const width = cards[0].getBoundingClientRect().width;
      return width ? Math.round(this.track.scrollLeft / width) : 0;
    }

    goTo(index) {
      const cards = this.cards;
      const target = cards[Math.max(0, Math.min(cards.length - 1, index))];
      if (!target) return;
      this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }

    sync() {
      const index = this.current;
      this.dots.forEach((dot) => {
        dot.setAttribute('aria-current', Number(dot.dataset.scrollTo) === index ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('products-with-image')) {
    customElements.define('products-with-image', ProductsWithImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const popup = document.querySelector('[data-popup]');
    if (!popup) return;

    const COOKIE_NAME = 'popup_dismissed';

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? match[1] : null;
    }

    function setCookie(name, value, days) {
      document.cookie = name + '=' + value + '; path=/; max-age=' + days * 60 * 60 * 24;
    }

    if (getCookie(COOKIE_NAME)) return;

    const delay = parseInt(popup.dataset.delay, 10) || 5000;
    const cookieDays = parseInt(popup.dataset.cookieDays, 10) || 7;

    setTimeout(() => {
      popup.hidden = false;
    }, delay);

    function dismiss() {
      popup.hidden = true;
      setCookie(COOKIE_NAME, '1', cookieDays);
    }

    popup.querySelectorAll('[data-popup-close]').forEach((el) => el.addEventListener('click', dismiss));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) dismiss();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !Shopify.designMode) return;
  try {
    
  class PressCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-press-track]');
      this.prevButton = this.querySelector('[data-press-prev]');
      this.nextButton = this.querySelector('[data-press-next]');
      if (!this.track || !this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.updateArrows());
        this.observer.observe(this.track);
      }

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    // `scrollBy` is measured in physical pixels, so "next" is a negative
    // offset once the track reads right-to-left. scrollLeft counts the same
    // way — from 0 down into negative numbers — which is why the distance
    // travelled is read as an absolute value below.
    #rtl() {
      return getComputedStyle(this.track).direction === 'rtl';
    }

    scrollByCard(direction) {
      const card = this.track.children[0];
      if (!card) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: card.getBoundingClientRect().width * direction * (this.#rtl() ? -1 : 1),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrolled = Math.abs(this.track.scrollLeft);
      const atStart = scrolled <= 1;
      const atEnd = scrolled >= maxScroll - 1;

      this.prevButton.hidden = atStart;
      this.nextButton.hidden = atEnd;

      if (maxScroll <= 1) {
        this.prevButton.hidden = true;
        this.nextButton.hidden = true;
      }
    }
  }

  if (!customElements.get('press-carousel')) {
    customElements.define('press-carousel', PressCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.variants = this.readJSON('[data-variant-data]', []);
      this.strings = this.readJSON('[data-variant-strings]', {});

      this.idInput = this.querySelector('[data-variant-id]');
      if (this.idInput) this.idInput.disabled = false;

      this.bindOptions();
      this.markUnavailableOptions();
    }

    bindOptions() {
      this.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });
      this.querySelectorAll('[data-option-select]').forEach((select) => {
        select.addEventListener('change', () => this.onOptionChange());
      });
    }

    readJSON(selector, fallback) {
      const node = this.querySelector(selector);
      if (!node) return fallback;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return fallback;
      }
    }

    selectedOptions() {
      const values = [];
      this.querySelectorAll('[data-option-input]:checked').forEach((input) => {
        values[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      this.querySelectorAll('[data-option-select]').forEach((select) => {
        values[Number(select.dataset.optionPosition) - 1] = select.value;
      });
      return values;
    }

    matchVariant(options) {
      return this.variants.find((variant) =>
        variant.options.every((value, index) => value === options[index])
      );
    }

    onOptionChange() {
      const options = this.selectedOptions();

      this.querySelectorAll('[data-option-input]:checked').forEach((input) => {
        const label = this.querySelector(`[data-option-selected="${input.dataset.optionPosition}"]`);
        if (label) label.textContent = input.value;
      });
      this.querySelectorAll('[data-option-select]').forEach((select) => {
        const label = this.querySelector(`[data-option-selected="${select.dataset.optionPosition}"]`);
        if (label) label.textContent = select.value;
      });

      this.markUnavailableOptions();

      const variant = this.matchVariant(options);
      if (!variant) {
        this.setUnavailable();
        return;
      }
      this.updateVariant(variant);
    }

    setUnavailable() {
      if (this.idInput) this.idInput.value = '';
      const button = this.querySelector('[data-add-to-cart]');
      const text = this.querySelector('[data-add-to-cart-text]');
      if (button) button.disabled = true;
      if (text) text.textContent = this.strings.unavailable;
    }

    updateVariant(variant) {
      if (this.idInput) this.idInput.value = variant.id;

      const button = this.querySelector('[data-add-to-cart]');
      const text = this.querySelector('[data-add-to-cart-text]');
      if (button) button.disabled = !variant.available;
      if (text) {
        text.textContent = variant.available ? this.strings.addToCart : this.strings.soldOut;
      }

      this.renderPrice(variant);
      this.renderSku(variant);
      this.applyQuantityRules(variant);

      if (variant.media_id) this.showMedia(String(variant.media_id));

      if (this.dataset.updateUrl === 'true') {
        window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variant.id}`);
      }

      // Blocks that depend on the variant (inventory, pickup) re-render
      // themselves from the section rendering API.
      this.refreshVariantBlocks(variant);
    }

    renderPrice(variant) {
      const target = this.querySelector('[data-product-price]');
      if (!target) return;

      const wrapper = document.createElement('div');
      wrapper.className = variant.compare_at_price ? 'price price--on-sale' : 'price';

      if (variant.compare_at_price) {
        const compare = document.createElement('span');
        compare.className = 'price__compare-at';
        compare.textContent = variant.compare_at_price;
        const sale = document.createElement('span');
        sale.className = 'price__sale';
        sale.textContent = variant.price;
        wrapper.append(compare, sale);
      } else {
        const regular = document.createElement('span');
        regular.className = 'price__regular';
        regular.textContent = variant.price;
        wrapper.appendChild(regular);
      }

      const existing = target.querySelector('.price');
      if (existing) existing.replaceWith(wrapper);
      else target.prepend(wrapper);
    }

    renderSku(variant) {
      const wrapper = this.querySelector('[data-product-sku]');
      if (!wrapper) return;
      const value = wrapper.querySelector('[data-product-sku-value]');
      if (value) value.textContent = variant.sku || '';
      wrapper.hidden = !variant.sku;
    }

    applyQuantityRules(variant) {
      const input = this.querySelector('[data-product-quantity]');
      if (!input) return;
      input.min = variant.quantity_min;
      input.step = variant.quantity_increment;
      if (Number(input.value) < variant.quantity_min) input.value = variant.quantity_min;
    }

    async refreshVariantBlocks(variant) {
      const inventory = this.querySelector('[data-product-inventory]');
      const pickup = this.querySelector('[data-product-pickup]');
      if (!inventory && !pickup) return;

      try {
        const url = `${this.dataset.productUrl}?variant=${variant.id}&section_id=${this.dataset.sectionId}`;
        const response = await fetch(url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        ['[data-product-inventory]', '[data-product-pickup]'].forEach((selector) => {
          const fresh = doc.querySelector(selector);
          const current = this.querySelector(selector);
          if (fresh && current) current.replaceWith(fresh);
        });
      } catch (error) {
        /* Stale stock text is better than a broken page. */
      }
    }

    /**
     * Mark option values that cannot be combined with the current selection,
     * checking one option position at a time.
     */
    markUnavailableOptions() {
      const selected = this.selectedOptions();

      this.querySelectorAll('[data-option-input]').forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const candidate = selected.slice();
        candidate[position] = input.value;

        const match = this.variants.find((variant) =>
          variant.options.every(
            (value, index) => candidate[index] === undefined || value === candidate[index]
          )
        );

        const label = input.closest('.variant-picker__value');
        if (label) {
          label.classList.toggle('variant-picker__value--unavailable', !match || !match.available);
        }
      });
    }

    showMedia(mediaId) {
      this.dispatchEvent(
        new CustomEvent('product:media', { detail: { mediaId }, bubbles: true })
      );
    }
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-list"] && !Shopify.designMode) return;
  try {
    
  class QuickOrderList extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.totalNode = this.querySelector('[data-quick-order-total]');
      this.status = this.querySelector('[data-quick-order-status]');
      this.inputs = Array.from(this.querySelectorAll('[data-quick-order-qty]'));

      this.inputs.forEach((input) => {
        input.addEventListener('input', () => this.updateTotal());
      });

      this.form.addEventListener('submit', (event) => this.submit(event));
      this.updateTotal();
    }

    // Totals are shown in the shop's own format, taken from the rendered
    // subtotal cell so no currency logic is reimplemented here.
    updateTotal() {
      const cents = this.inputs.reduce((sum, input) => {
        const qty = parseInt(input.value, 10) || 0;
        return sum + qty * Number(input.dataset.price);
      }, 0);

      if (!this.totalNode) return;
      const template = this.totalNode.textContent.replace(/[\d.,]+/, '');
      const amount = (cents / 100).toFixed(2);
      this.totalNode.textContent = template.trim()
        ? this.totalNode.textContent.replace(/[\d.,]+/, amount)
        : amount;
    }

    async submit(event) {
      const anything = this.inputs.some((input) => (parseInt(input.value, 10) || 0) > 0);
      if (!anything) {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      const items = this.inputs
        .map((input) => {
          const qty = parseInt(input.value, 10) || 0;
          if (qty <= 0) return null;
          const idField = input.parentElement.querySelector('input[type="hidden"]');
          return { id: Number(idField.value), quantity: qty };
        })
        .filter(Boolean);

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) throw new Error('Add to cart failed');

        this.inputs.forEach((input) => {
          input.value = 0;
        });
        this.updateTotal();

        if (this.status) {
          this.status.hidden = false;
          this.status.textContent = this.status.dataset.success || 'Added to cart';
        }

        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      } catch (error) {
        // Fall back to the plain form post.
        this.form.submit();
      }
    }
  }

  if (!customElements.get('quick-order-list')) {
    customElements.define('quick-order-list', QuickOrderList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;
    const body = modal.querySelector('[data-quick-view-body]');

    function open(handle) {
      modal.hidden = false;
      body.innerHTML = '<p class="quick-view-modal__loading">Loading...</p>';
      fetch('/products/' + handle + '?view=quick-view')
        .then((res) => res.text())
        .then((html) => {
          // The quick-view template renders as a full page now (so it's
          // selectable in the theme editor's alternate-template picker,
          // which hides layout: false templates) rather than a bare
          // fragment — so the response includes the whole header/footer.
          // Only the one section we actually want is pulled out of it.
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fragment = doc.querySelector('[data-quick-view-fragment]');
          body.innerHTML = fragment
            ? fragment.outerHTML
            : '<p>Sorry, this product could not be loaded.</p>';
        })
        .catch(() => {
          body.innerHTML = '<p>Sorry, this product could not be loaded.</p>';
        });
    }

    function close() {
      modal.hidden = true;
    }

    document.addEventListener('quick-view:open', (e) => {
      if (e.detail && e.detail.handle) open(e.detail.handle);
    });

    modal.querySelectorAll('[data-quick-view-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const COOKIE_NAME = 'recently_viewed_products';

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? JSON.parse(decodeURIComponent(match[1])) : [];
    }

    function setCookie(name, value) {
      document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + '; path=/; max-age=' + 60 * 60 * 24 * 30;
    }

    document.addEventListener('DOMContentLoaded', () => {
      const section = document.querySelector('[data-recently-viewed]');
      if (!section) return;

      const currentHandle = section.dataset.currentHandle;
      const limit = parseInt(section.dataset.limit, 10) || 4;
      let handles = getCookie(COOKIE_NAME);

      if (currentHandle) {
        handles = handles.filter((h) => h !== currentHandle);
        handles.unshift(currentHandle);
        handles = handles.slice(0, 12);
        setCookie(COOKIE_NAME, handles);
      }

      const toShow = handles.filter((h) => h !== currentHandle).slice(0, limit);
      if (toShow.length === 0) return;

      const grid = section.querySelector('[data-recently-viewed-grid]');
      Promise.all(
        toShow.map((handle) =>
          fetch('/products/' + handle + '?view=card')
            .then((res) => (res.ok ? res.text() : ''))
            .catch(() => '')
        )
      ).then((results) => {
        const html = results.filter(Boolean).join('');
        if (html.trim() !== '') {
          grid.innerHTML = html;
          section.hidden = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-recommendations]').forEach((el) => {
      fetch(el.dataset.url)
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newContent = doc.querySelector('[data-product-recommendations]');
          if (newContent && newContent.innerHTML.trim() !== '') {
            el.innerHTML = newContent.innerHTML;
          }
        })
        .catch(() => {});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-promotion"] && !Shopify.designMode) return;
  try {
    
  class ScrollingPromo extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-promo-track]');
      this.group = this.querySelector('[data-promo-group]');
      if (!this.track || !this.group || this.group.children.length === 0) return;

      // connectedCallback runs again if the element is moved in the DOM, and
      // building twice would leave a track of stale copies.
      if (this.built) return;
      this.built = true;

      // Web fonts change how wide the content is, so the first measurement has
      // to wait for them or the loop is timed against fallback letterforms.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.build());
      } else {
        this.build();
      }

      this.onResize = () => this.build();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    /**
     * Lays down as many copies of the authored group as it takes to keep the
     * viewport covered, then times the loop from the measured width.
     */
    build() {
      const width = this.group.getBoundingClientRect().width;
      if (!width) return;

      // Enough copies that the copies trailing the first one can cover the
      // viewport on their own — otherwise the track runs out of content part
      // way through and the loop visibly snaps back.
      const copies = Math.max(2, Math.ceil(window.innerWidth / width) + 1);
      // The setting is a rate, and this constant is what it means in pixels
      // per second: the slider spans 30–300px/s, where it used to span
      // 100–1000. Shopify will not accept a decimal range step finer than
      // 0.1, so the slider itself cannot be subdivided any further — moving
      // the scale here is what makes its slow end genuinely slow. The default
      // of 0.3 now works out at 90px/s, the same rate every other marquee in
      // the theme runs at (see animations.js).
      const speed = parseFloat(this.dataset.speed) || 0.3;
      const duration = width / (speed * 300);

      // Nothing meaningful changed, so leave the running animation alone.
      if (this.copies === copies && Math.abs((this.duration || 0) - duration) < 0.01) return;

      this.copies = copies;
      this.duration = duration;

      this.track.querySelectorAll('[data-promo-copy]').forEach((node) => node.remove());

      for (let i = 1; i < copies; i += 1) {
        const clone = this.group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-promo-copy', '');
        clone.removeAttribute('data-promo-group');
        this.track.appendChild(clone);
      }

      this.style.setProperty('--promo-copies', copies);
      this.style.setProperty('--promo-duration', `${duration}s`);

      // Restart rather than re-time: an animation whose duration changes
      // part way through keeps its elapsed time, which lands it at a
      // different point in the loop and reads as a skip.
      this.track.style.animation = 'none';
      void this.track.offsetWidth;
      this.track.style.animation = '';

      this.setAttribute('data-ready', '');
    }
  }

  if (!customElements.get('scrolling-promo')) {
    customElements.define('scrolling-promo', ScrollingPromo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"] && !Shopify.designMode) return;
  try {
    
  class SearchDrawer extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.resultsContent = this.querySelector('[data-search-results-content]');
      this.limit = parseInt(this.dataset.limit, 10) || 6;
      this.timer = null;

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-search-drawer-trigger]')) {
          event.preventDefault();
          this.open();
        }
      });

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-search-drawer-close]')) this.close();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(this.input.value.trim()), 250);
      });
    }

    open() {
      this.hidden = false;
      document.body.classList.add('scroll-locked');
      this.input.focus();
    }

    close() {
      this.hidden = true;
      document.body.classList.remove('scroll-locked');
    }

    async search(term) {
      if (term.length < 2) {
        this.resultsContent.innerHTML = '';
        return;
      }

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': this.limit,
      });

      this.results.setAttribute('data-loading', '');

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}search/suggest.json?${params}`
        );

        if (!response.ok) return;

        const data = await response.json();
        this.renderResults(data.resources.results.products || [], term);
      } catch (error) {
        // Leave whatever was already showing rather than clearing it out from
        // under the visitor on a network hiccup.
      } finally {
        this.results.removeAttribute('data-loading');
      }
    }

    renderResults(products, term) {
      if (!products.length) {
        this.resultsContent.innerHTML = '<p class="search-drawer__empty"></p>';
        this.resultsContent.querySelector('p').textContent = `No results for "${term}"`;
        return;
      }

      const list = document.createElement('ul');
      list.className = 'search-drawer__list';
      list.setAttribute('data-animate-panel', '');
      list.setAttribute('data-state', 'closed');

      products.forEach((product) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'search-drawer__result';
        link.href = product.url;

        if (product.featured_image && product.featured_image.url) {
          const img = document.createElement('img');
          img.src = product.featured_image.url;
          img.alt = '';
          img.loading = 'lazy';
          link.appendChild(img);
        }

        const title = document.createElement('span');
        title.className = 'search-drawer__result-title';
        title.textContent = product.title;
        link.appendChild(title);

        item.appendChild(link);
        list.appendChild(item);
      });

      this.resultsContent.innerHTML = '';
      this.resultsContent.appendChild(list);

      // Inserted closed so there is a state to transition from, then flipped
      // open on the next frame so the browser actually animates the change
      // instead of collapsing it into the initial paint.
      requestAnimationFrame(() => {
        list.setAttribute('data-state', 'open');
      });
    }
  }

  if (!customElements.get('search-drawer')) {
    customElements.define('search-drawer', SearchDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideShow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slideshow-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length === 0) return;

      this.transition = this.dataset.transition;
      this.speed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.index = 0;
      this.paused = false;

      this.controls = this.querySelector('[data-slideshow-controls]');
      this.#buildDots();
      this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
      this.pauseButton = this.querySelector('[data-slide-pause]');

      if (this.controls && this.slides.length > 1) this.controls.hidden = false;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.index));
          this.restart();
        });
      });

      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', () => this.togglePause());
      }

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => {
          if (!this.paused) this.start();
        });
      }

      // Respect a visitor's motion preference: no auto-rotation.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onResize = () => this.#fitToSlide();
      window.addEventListener('resize', this.onResize);

      this.goTo(0);

      /* Hands the first-slide styling over to `data-active`. Set after goTo so
         there is never a frame where neither rule applies. */
      this.setAttribute('data-ready', '');
      if (this.autoplay && !this.reduceMotion) this.start();
    }

    // The controls are a static block, and a block cannot read the section's
    // block list — so it renders an empty rail and the bars are built here,
    // where the slides are already known.
    #buildDots() {
      const rail = this.querySelector('[data-slideshow-progress]');
      if (!rail || rail.children.length) return;

      this.slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'slideshow__bar icon-button';
        dot.dataset.slideDot = '';
        dot.dataset.index = String(index);
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', rail.dataset.slideLabel.replace('%i%', String(index + 1)));
        dot.setAttribute('aria-selected', String(index === 0));
        dot.innerHTML = '<span class="slideshow__bar-fill"></span>';
        rail.appendChild(dot);
      });
    }

    disconnectedCallback() {
      this.stop();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    // Original ratio only: match the viewport to the slide on screen. Every
    // other height is fixed, so there is nothing to work out.
    #fitToSlide() {
      if (!this.classList.contains('slideshow--original')) return;

      const slide = this.slides[this.index];
      const viewport = this.querySelector('.slideshow__viewport');
      if (!slide || !viewport) return;

      const mobile = window.matchMedia('(max-width: 699px)').matches;
      const ratio = parseFloat(mobile ? slide.dataset.ratioMobile : slide.dataset.ratioDesktop);
      if (!ratio) return;

      viewport.style.height = `${viewport.clientWidth / ratio}px`;
    }

    goTo(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.#fitToSlide();

      if (this.transition === 'slide') {
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
      }

      this.slides.forEach((slide, i) => {
        slide.toggleAttribute('data-active', i === this.index);
        // Keep off-screen slides out of the tab order.
        slide.inert = i !== this.index && this.transition !== 'slide';
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.style.setProperty('--bar-duration', active && this.timer ? `${this.speed}ms` : '0.3s');
      });
    }

    next() {
      this.goTo(this.index + 1);
    }

    start() {
      this.stop();
      if (!this.autoplay || this.reduceMotion) return;
      this.timer = setInterval(() => this.next(), this.speed);
      this.goTo(this.index);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      if (this.paused) return;
      this.start();
    }

    togglePause() {
      this.paused = !this.paused;
      this.pauseButton.toggleAttribute('data-paused', this.paused);
      if (this.paused) this.stop();
      else this.start();
    }
  }

  if (!customElements.get('slide-show')) {
    customElements.define('slide-show', SlideShow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  /**
   * Turns the attribute rows into disclosures, but only when the section asked
   * for it. A row's summary is always a button so the markup does not change
   * with the setting; where nothing collapses the button is taken out of the
   * tab order and marked as not a control.
   */
  class SpecList extends HTMLElement {
    connectedCallback() {
      const collapsing = this.hasAttribute('data-collapse');

      if (!collapsing) {
        this.querySelectorAll('.spec-row__summary').forEach((button) => {
          button.setAttribute('tabindex', '-1');
          button.setAttribute('aria-disabled', 'true');
          button.removeAttribute('aria-expanded');
        });
        return;
      }

      this.addEventListener('click', (event) => {
        const button = event.target.closest('.spec-row__summary');
        if (!button || !this.contains(button)) return;

        const row = button.closest('.spec-row');
        const open = row.toggleAttribute('data-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('spec-list')) {
    customElements.define('spec-list', SpecList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  class StatsRow extends HTMLElement {
    connectedCallback() {
      this.numbers = Array.from(this.querySelectorAll('[data-count-to]'));
      if (!this.numbers.length) return;

      // No observer support means the markup's final values simply stay put.
      if (!('IntersectionObserver' in window)) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.animate(entry.target);
            this.observer.unobserve(entry.target);
          });
        },
        { threshold: 0.4 }
      );

      this.numbers.forEach((el) => this.observer.observe(el));
    }

    animate(el) {
      const target = parseFloat(el.dataset.countTo);
      if (Number.isNaN(target)) return;

      const duration = 1200;
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        // Ease out so the number decelerates into its final value.
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toString();
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toString();
      };

      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('stats-row')) {
    customElements.define('stats-row', StatsRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-bar"]) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-sticky-atc]');
    // Scoped to #MainContent so this only ever matches the main product
    // section's own form — the quick-view modal (sections/quick-view.liquid)
    // renders its own `.buy-buttons__form` outside #MainContent (in the
    // overlay group, after </main> in layout/theme.liquid), so an unscoped
    // query could otherwise pick either one when both are present.
    const form = document.querySelector('#MainContent .buy-buttons__form');
    if (!bar || !form || !('IntersectionObserver' in window)) return;

    // Submit the main product form, whichever section id it was rendered with.
    const button = bar.querySelector('[data-sticky-atc-button]');
    if (button && form.id) button.setAttribute('form', form.id);

    // Mirror the main add-to-cart button's disabled state as variants change.
    const mainButton = form.querySelector('[data-add-to-cart]');
    if (button && mainButton) {
      new MutationObserver(() => {
        button.disabled = mainButton.disabled;
      }).observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.hidden = false;
          bar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(form);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  /* Clicking a location points the section's single map at it. */
  class StoreLocator extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-store-map]');
      this.pane = this.querySelector('[data-store-map-pane]');
      this.locations = Array.from(this.querySelectorAll('[data-location]'));
      if (!this.frame || this.locations.length === 0) return;

      // The map opens on the first location that has one, so the list and the
      // map agree from the start rather than after the first click.
      this.pane.hidden = false;
      this.select(this.locations[0]);

      this.locations.forEach((location) => {
        location.addEventListener('click', (event) => {
          // Get directions keeps its own job.
          if (event.target.closest('a')) return;
          this.select(location);
        });

        location.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          if (event.target.closest('a')) return;
          event.preventDefault();
          this.select(location);
        });
      });
    }

    select(location) {
      const url = location.dataset.embed;
      // Reassigning the same src reloads the iframe for no reason.
      if (url && this.frame.getAttribute('src') !== url) this.frame.setAttribute('src', url);

      this.locations.forEach((node) => {
        const selected = node === location;
        node.classList.toggle('is-selected', selected);
        node.setAttribute('aria-pressed', String(selected));
      });
    }
  }

  if (!customElements.get('store-locator')) {
    customElements.define('store-locator', StoreLocator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  class TimeLine extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-timeline-index]');
        if (button && button.tagName === 'BUTTON') this.select(button.dataset.timelineIndex);
      });

      // The editor selects a block when a merchant picks it in the sidebar,
      // so bring that entry forward rather than leaving them on another one.
      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const button = event.target.closest('[data-timeline-index]');
          if (button) this.select(button.dataset.timelineIndex);
        });
      }
    }

    select(index) {
      if (index == null) return;

      this.querySelectorAll('.timeline__nav-item').forEach((node) => {
        node.setAttribute('aria-current', String(node.dataset.timelineIndex === index));
      });

      this.querySelectorAll('.timeline-step, .timeline__media').forEach((node) => {
        node.classList.toggle('is-selected', node.dataset.timelineIndex === index);
      });
    }
  }

  if (!customElements.get('time-line')) {
    customElements.define('time-line', TimeLine);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-icons"] && !Shopify.designMode) return;
  try {
    
  // Markers both report where the row is and move it.
  class TrustIconsMarkers extends HTMLElement {
    connectedCallback() {
      this.rail = this.parentElement?.querySelector('[data-trust-rail]');
      this.markers = Array.from(this.children);
      if (!this.rail || !this.markers.length) return;

      this.sync = this.sync.bind(this);
      this.rail.addEventListener('scroll', this.sync, { passive: true });

      this.markers.forEach((marker, index) => {
        marker.addEventListener('click', () => {
          const item = this.rail.children[index];
          if (item) this.rail.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        });
      });

      this.sync();
    }

    disconnectedCallback() {
      this.rail?.removeEventListener('scroll', this.sync);
    }

    sync() {
      // Which item is nearest the middle of the view, rather than which has
      // scrolled furthest — the last item never reaches the left edge.
      const middle = this.rail.scrollLeft + this.rail.clientWidth / 2;
      let nearest = 0;
      let best = Infinity;

      Array.from(this.rail.children).forEach((item, index) => {
        const centre = item.offsetLeft + item.offsetWidth / 2;
        const distance = Math.abs(centre - middle);
        if (distance < best) {
          best = distance;
          nearest = index;
        }
      });

      this.markers.forEach((marker, index) => {
        marker.setAttribute('aria-current', index === nearest ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('trust-icons-markers')) {
    customElements.define('trust-icons-markers', TrustIconsMarkers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  /**
   * Starts the video on request.
   *
   * An external video's iframe is only written when playback is asked for, so
   * arriving at the page never loads a third-party player. A hosted video is
   * already in the document and simply plays.
   */
  class VideoSection extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-video-frame]');
      if (!this.frame) return;

      this.native = this.querySelector('[data-video-native]');
      this.embed = this.querySelector('[data-video-embed]');

      // Autoplaying leaves nothing to press, so the overlay steps aside.
      if (this.hasAttribute('data-autoplay') && this.native) {
        this.setAttribute('data-playing', '');
      }

      this.addEventListener('click', (event) => {
        if (!event.target.closest('[data-video-play]')) return;
        this.play();
      });
    }

    play() {
      this.setAttribute('data-playing', '');

      if (this.native) {
        this.native.setAttribute('controls', '');
        const started = this.native.play();
        if (started && started.catch) started.catch(() => {});
        return;
      }

      if (!this.embed || this.embed.querySelector('iframe')) return;

      const id = this.embed.dataset.videoId;
      const type = this.embed.dataset.videoType;
      const controls = this.embed.dataset.videoControls === 'true' ? '1' : '0';
      if (!id) return;

      const src =
        type === 'vimeo'
          ? `https://player.vimeo.com/video/${id}?autoplay=1&controls=${controls}`
          : `https://www.youtube.com/embed/${id}?autoplay=1&controls=${controls}&rel=0&playsinline=1`;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.title = this.dataset.videoTitle || 'Video';

      this.embed.innerHTML = '';
      this.embed.appendChild(iframe);
    }
  }

  if (!customElements.get('video-section')) {
    customElements.define('video-section', VideoSection);
  }

  } catch(e) { console.error(e); }
})();
})();
